import React, { useEffect } from "react";
import {
  ACCESS_DENIED,
  ADMIN_CONTRACTOR_CONFIGURATION_LIST,
  ADMIN_CONTRACTOR_LIST,
  ADMIN_CONTRACTOR_MAPPING,
} from "../../../constant/routeContant";
import { useNavigate } from "react-router-dom";
import ContractorManagementList from "../component/contractorManagement/contractorManagementList";
import { checkPrivileges } from "../../../utils/rolesHelper";
import * as userAction from "../../../redux/actions/userAction";
import { useDispatch } from "react-redux";

const ContractorManagementContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(userAction.ClearSendBulkEmailVerification());
  }, []);

  const onClickHandler = (id) => {
    if (id === 1) {
      navigate(ADMIN_CONTRACTOR_LIST);
    }
    else if (id === 2) {
      navigate(ADMIN_CONTRACTOR_CONFIGURATION_LIST);
    }
  };

  return (
    <>
      <div className="dashTitle"> Contractor Management</div>
      <ContractorManagementList onClick={onClickHandler} />
    </>
  );
};

export default ContractorManagementContainer;
